import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '../../ui/Card';
import { Button } from '../../ui/Button';
import toast from 'react-hot-toast';

export function NewsletterSettings({ settings, onUpdate }) {
  const [formData, setFormData] = useState(settings);

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdate(formData);
    toast.success('Newsletter-Einstellungen wurden aktualisiert');
  };

  return (
    <Card>
      <CardHeader>
        <h2 className="text-gray-900 dark:text-white text-lg font-semibold">Newsletter & Kommunikation</h2>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-4">
            <label className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={formData.newsletters.product}
                onChange={(e) => setFormData({
                  ...formData,
                  newsletters: { ...formData.newsletters, product: e.target.checked }
                })}
                className="checkbox-custom"
              />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">Produkt-Updates</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Erhalten Sie Updates zu neuen Funktionen</p>
              </div>
            </label>

            <label className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={formData.newsletters.marketing}
                onChange={(e) => setFormData({
                  ...formData,
                  newsletters: { ...formData.newsletters, marketing: e.target.checked }
                })}
                className="checkbox-custom"
              />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">Marketing</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Erhalten Sie Angebote und Promotionen</p>
              </div>
            </label>

            <label className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={formData.newsletters.blog}
                onChange={(e) => setFormData({
                  ...formData,
                  newsletters: { ...formData.newsletters, blog: e.target.checked }
                })}
                className="checkbox-custom"
              />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">Blog & News</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Erhalten Sie Updates zu unserem Blog</p>
              </div>
            </label>
          </div>

          <div className="pt-4 border-t border-gray-100 dark:border-gray-800">
            <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-4">Benachrichtigungshäufigkeit</h3>
            
            <div className="space-y-4">
              <label className="flex items-center gap-3">
                <input
                  type="radio"
                  name="frequency"
                  value="daily"
                  checked={formData.frequency === 'daily'}
                  onChange={(e) => setFormData({ ...formData, frequency: e.target.value })}
                  className="checkbox-custom"
                />
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-white">Täglich</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">Tägliche Zusammenfassung</p>
                </div>
              </label>

              <label className="flex items-center gap-3">
                <input
                  type="radio"
                  name="frequency"
                  value="weekly"
                  checked={formData.frequency === 'weekly'}
                  onChange={(e) => setFormData({ ...formData, frequency: e.target.value })}
                  className="checkbox-custom"
                />
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-white">Wöchentlich</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">Wöchentliche Zusammenfassung</p>
                </div>
              </label>

              <label className="flex items-center gap-3">
                <input
                  type="radio"
                  name="frequency"
                  value="monthly"
                  checked={formData.frequency === 'monthly'}
                  onChange={(e) => setFormData({ ...formData, frequency: e.target.value })}
                  className="checkbox-custom"
                />
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-white">Monatlich</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">Monatliche Zusammenfassung</p>
                </div>
              </label>
            </div>
          </div>

          <div className="flex justify-end">
            <Button type="submit">Einstellungen speichern</Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}